import 'isomorphic-fetch';

import { h, render } from 'preact';
import './font-awesome';
import './style';

let root;
function init() {

  // warm up heroku so its ready by the time we load /book
  fetch(API_HOST);

  let App = require('./components/app').default;
  root = render(<App />, document.body, root);
}

init();

if (process.env.NODE_ENV==='development' && module.hot) {
  module.hot.accept('./components/app', () => requestAnimationFrame(init));
}


// WEBPACK FOOTER //
// ./index.js